export type FaceId =
  | "play"
  | "augment"
  | "mobile"
  | "react-native"
  | "ai"
  | "trade"
  | "build"
  | "engine";

export interface Face {
  id: FaceId;
  label: string;
  shortLabel: string;
  route: `/${FaceId}`;
  themeVar: `--color-jg-${FaceId}`;
  themeColor: string;
  blurb: string;
}

export const FACES: readonly Face[] = [
  {
    id: "play",
    label: "Jogos",
    shortLabel: "Jogos",
    route: "/play",
    themeVar: "--color-jg-play",
    themeColor: "#22427c",
    blurb: "Jogos em Unity para marcas licenciadas, publicados nas duas lojas.",
  },
  {
    id: "augment",
    label: "Realidade aumentada",
    shortLabel: "RA/RV",
    route: "/augment",
    themeVar: "--color-jg-augment",
    themeColor: "#22427c",
    blurb: "Realidade aumentada e virtual com Vuforia e AR Foundation.",
  },
  {
    id: "mobile",
    label: "Android",
    shortLabel: "Android",
    route: "/mobile",
    themeVar: "--color-jg-mobile",
    themeColor: "#22427c",
    blurb: "Android nativo com Kotlin e Jetpack Compose, publicado e mantido.",
  },
  {
    id: "react-native",
    label: "React Native",
    shortLabel: "RN",
    route: "/react-native",
    themeVar: "--color-jg-react-native",
    themeColor: "#22427c",
    blurb: "Um código só, nas duas lojas, com React Native.",
  },
  {
    id: "ai",
    label: "Inteligência artificial",
    shortLabel: "IA",
    route: "/ai",
    themeVar: "--color-jg-ai",
    themeColor: "#22427c",
    blurb: "Modelo de linguagem dentro de produto, e a automação em volta.",
  },
  {
    id: "trade",
    label: "Fintech",
    shortLabel: "Fintech",
    route: "/trade",
    themeVar: "--color-jg-trade",
    themeColor: "#22427c",
    blurb: "Automação de mercado e interface de terminal. Veja o Cypher Bot.",
  },
  {
    id: "build",
    label: "Trabalho",
    shortLabel: "Trabalho",
    route: "/build",
    themeVar: "--color-jg-build",
    themeColor: "#22427c",
    blurb: "Dez anos de coisa publicada, ano a ano.",
  },
  {
    id: "engine",
    label: "Motores",
    shortLabel: "Motores",
    route: "/engine",
    themeVar: "--color-jg-engine",
    themeColor: "#22427c",
    blurb: "Unity e Unreal, do protótipo até a loja.",
  },
] as const;

export const FACE_BY_ID: Record<FaceId, Face> = Object.fromEntries(
  FACES.map((f) => [f.id, f]),
) as Record<FaceId, Face>;

/**
 * 2×2×2 Rubik's-cube cubie positions. Each cubie sits at a corner of a unit
 * cube, with the most-strategic skills placed on cubies that face the camera
 * at the default angle ([3.5, 2.5, 3.5]).
 */
export const CUBIE_OFFSET = 0.5;
export const CUBIE_SIZE = 0.96;

export const CUBIE_POSITIONS: Record<FaceId, [number, number, number]> = {
  ai:             [+CUBIE_OFFSET, +CUBIE_OFFSET, +CUBIE_OFFSET], // hero — closest to camera
  play:           [-CUBIE_OFFSET, +CUBIE_OFFSET, +CUBIE_OFFSET],
  trade:          [+CUBIE_OFFSET, -CUBIE_OFFSET, +CUBIE_OFFSET],
  "react-native": [-CUBIE_OFFSET, -CUBIE_OFFSET, +CUBIE_OFFSET],
  augment:        [+CUBIE_OFFSET, +CUBIE_OFFSET, -CUBIE_OFFSET],
  mobile:         [-CUBIE_OFFSET, +CUBIE_OFFSET, -CUBIE_OFFSET],
  build:          [+CUBIE_OFFSET, -CUBIE_OFFSET, -CUBIE_OFFSET],
  engine:         [-CUBIE_OFFSET, -CUBIE_OFFSET, -CUBIE_OFFSET],
};
